import { render, staticRenderFns } from "./OtherAlertsTable.vue?vue&type=template&id=1760a9ca"
import script from "./OtherAlertsTable.vue?vue&type=script&lang=js"
export * from "./OtherAlertsTable.vue?vue&type=script&lang=js"
import style0 from "./OtherAlertsTable.vue?vue&type=style&index=0&id=1760a9ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports